/**
 * productPickerConfig.ts
 *
 * Tunable knobs for the marketplace product picker's search behaviour.
 * Centralised so future env-var / feature-flag wiring is a one-line
 * change instead of a component refactor.
 */

/**
 * Auto-pagination scan target. When a search query is active, the picker
 * keeps fetching the next marketplace discovery page (via the existing cache
 * append flow) until at least this many products match the query.
 *
 * Default 20 = a full visible "page" of matches. The user can still click
 * Load More for additional matches beyond this.
 */
export const SEARCH_TARGET_MATCHES = 20

/**
 * Safety cap on auto-fetched TikTok pages per search scan. Prevents a
 * pathological query against a huge catalog from issuing hundreds of
 * sequential API calls. When the cap is hit before reaching the target
 * match count, the picker stops scanning and surfaces a hint that the
 * user can keep going via Load More.
 *
 * Default 25 pages ≈ 500 products scanned per search. Sized for shops
 * with deep catalogs (1k+ products); tune down if marketplace rate-limiting
 * becomes a concern, tune up for very large shops.
 */
export const SEARCH_MAX_PAGES = 25

/**
 * SKU escape hatch threshold. The picker fires a single `{ sku: query }`
 * server lookup only when the typed query reaches at least this length
 * (or is all-digit), the local cache has zero matches, and we haven't
 * already tried this exact query. Prevents the fallback from firing on
 * every short keystroke like "ea".
 */
export const SKU_FALLBACK_MIN_LENGTH = 8
